import {Component, Input} from '@angular/core';
import {DXCEligibilityResponsePlan, DXCEligibilityResponsePlanBenefit} from '../../../models/insurance/dxc/patient-eligibility';

@Component({
  selector: 'app-insurance-rtb-dialog-plan-details',
  templateUrl: './insurance-rtb-dialog-plan-details.component.html',
  styleUrls: ['./insurance-rtb-dialog-plan-details.component.scss']
})
export class InsuranceRtbDialogPlanDetailsComponent {
  @Input() jsonResp: DXCEligibilityResponsePlan;
}
